import { createI18n } from 'vue-i18n';
import en from '@src/locales/en.json';
import ru from '@src/locales/ru.json';

export const i18n = createI18n({
	fallbackLocale: 'en',
	legacy: false,
	locale: 'en',
	messages: {
		en,
		ru,
	},
});
